module.exports = __webpack_public_path__ + "static/media/icon_fork.f74f782a.svg";